import Big from 'big.js'

export class ProductCalc {
    static TonsFromLiter = (product, round = 4) => {
        const liters = parseFloat(product.AmountInLitre)
        const density = parseFloat(product.Density)
        if (!isNaN(liters) && !isNaN(density) && density != 0) {
            const bigLiters = new Big(liters)
            const bigDensity = new Big(density)
            const result = bigLiters
                .times(bigDensity)
                .div('1000')
                .round(round)
                .toString()
            product.AmountInTonne = result
            return result
        }
        return null
    }

    static LiterFromTons = product => {
        const tons = parseFloat(product.AmountInTonne)
        const density = parseFloat(product.Density)
        if (!isNaN(tons) && !isNaN(density)) {
            const bigTons = new Big(tons)
            const result = bigTons
                .times('1000')
                .div(density)
                .round()
                .toString()
            product.AmountInLitre = result
            return result
        }
        return null
    }

    static setTons(product) {
        const result = ProductCalc.LiterFromTons(product)
        product.AmountInLitre = result
        return result
    }

    static setLiter(product) {
        const result = ProductCalc.TonsFromLiter(product)
        product.AmountInTonne = result
        return result
    }

    static density = (product, round = 3) => {
        const density = parseFloat(product.Density)
        if (!isNaN(density)) {
            const result = new Big(density).round(round).toString()
            product.Density = result
            return result
        }
        return null
    }

    static setPriceTons(product) {
        const result = ProductCalc.PriceLiter(product)
        product.GrossPricePerLitre = result
        return result
    }

    static setPriceLiter(product) {
        const result = ProductCalc.PriceTons(product)
        product.GrossPricePerTonne = result
        return result
    }

    static PriceTons = (product, round = 2) => {
        const priceLiter = parseFloat(product.GrossPricePerLitre)
        const liter = parseFloat(product.AmountInLitre)
        const tons = parseFloat(product.AmountInTonne)
        if (!isNaN(priceLiter) && !isNaN(liter) && !isNaN(tons)) {
            const bigLiterPrice = new Big(priceLiter)
            const bigLiters = new Big(liter)
            const bigTons = new Big(tons)
            return bigLiters
                .times(bigLiterPrice)
                .div(bigTons)
                .round(round)
                .toString()
        }
        return null
    }

    static PriceLiter = (product, round = 2) => {
        const priceTons = parseFloat(product.GrossPricePerTonne)
        const tons = parseFloat(product.AmountInTonne)
        const liters = parseFloat(product.AmountInLitre)
        if (!isNaN(priceTons) && !isNaN(tons) && !isNaN(liters)) {
            const bigPriceTons = new Big(priceTons)
            return bigPriceTons
                .times(tons)
                .div(liters)
                .round()
                .toString()
        }
        return null
    }

    static TotalExcise = product => {
        const tons = parseFloat(product.AmountInTonne)
        const Excise = parseFloat(product.tmpExcise)
        if (!isNaN(tons) && !isNaN(parseFloat(Excise))) {
            const bigTons = new Big(tons)
            const bigExcise = new Big(Excise)
            return bigTons
                .times(bigExcise)
                .round(2)
                .toString()
        }
        return null
    }

    static TmpTotalPrice(product) {
        const tons = parseFloat(product.AmountInTonne)
        const priceTons = parseFloat(product.GrossPricePerTonne)
        if (!isNaN(tons) && !isNaN(priceTons)) {
            const bigPriceTons = new Big(priceTons)
            return bigPriceTons.times(tons).toString()
        }
        return null
    }

    static AppendixTotalCalculate(product) {
        const liter = parseFloat(product.AmountInLitre)
        const literPrice = parseFloat(product.GrossPricePerLitre)

        if (!isNaN(liter) && !isNaN(literPrice)) {
            const bigLiter = new Big(liter)
            return bigLiter.times(literPrice).toString()
        }

        return null
    }

    static liter(product) {
        const liter = parseFloat(product.AmountInLitre)
        const literPrice = parseFloat(product.GrossPricePerLitre)
    }

    static tone(product) {

    }

    static TmpTotalNds(product) {
        const tmpTotalPrice = parseFloat(ProductCalc.TmpTotalPrice(product))
        const vatRate = parseInt(product.VATRate)
        if (!isNaN(tmpTotalPrice) && !isNaN(vatRate)) {
            return new Big(tmpTotalPrice)
                .times(vatRate)
                .div(100 + vatRate)
                .toString()
        }
        return null
    }

    static TmpPriceClearTons(product) {
        const tmpTotalPrice = parseFloat(ProductCalc.TmpTotalPrice(product))
        const totalExcise = parseFloat(ProductCalc.TotalExcise(product))
        const tmpTotalNds = parseFloat(ProductCalc.TmpTotalNds(product))

        if (!isNaN(tmpTotalPrice) && !isNaN(totalExcise) && !isNaN(tmpTotalNds)) {
            const result = new Big(tmpTotalPrice)
                .minus(totalExcise)
                .minus(tmpTotalNds)
                .toString()

            return result
        }
        return null
    }

    static PriceClearTon(product) {
        const priceClearTons = parseFloat(ProductCalc.TmpPriceClearTons(product))
        const tons = parseFloat(product.AmountInTonne)

        if (!isNaN(priceClearTons) && !isNaN(tons) && tons) {
            const bigPriceClearTons = new Big(priceClearTons).div(tons)
                .round(2)
                .toString()
            return bigPriceClearTons
        }
        return null
    }

    static PriceClearTons(product) {
        const priceClearTon = parseFloat(ProductCalc.PriceClearTon(product))
        const tons = parseFloat(product.AmountInTonne)
        if (!isNaN(priceClearTon) && !isNaN(tons)) {
            return new Big(priceClearTon)
                .times(tons)
                .round(2)
                .toString()
        }
        return null
    }

    //info
    static PriceClearNdsPrice(product) {
        const clearTon = parseFloat(ProductCalc.PriceClearTon(product))
        const Excise = parseFloat(product.tmpExcise)
        if (!isNaN(clearTon) && !isNaN(Excise)) {
            return new Big(clearTon).plus(Excise).toString()
        }
        return null
    }

    //info
    static PriceClearNdsPrices(product) {
        const clearTon = parseFloat(ProductCalc.PriceClearTons(product))
        const totalExcise = parseFloat(ProductCalc.TotalExcise(product))
        if (!isNaN(clearTon) && !isNaN(totalExcise)) {
            return new Big(clearTon).plus(totalExcise).toString()
        }
        return null
    }

    static TotalNds(product) {
        const priceClearTons = parseFloat(ProductCalc.PriceClearTons(product))
        const totalExcise = parseFloat(ProductCalc.TotalExcise(product))
        const vatRate = parseInt(product.VATRate)
        if (!isNaN(priceClearTons) && !isNaN(totalExcise) && !isNaN(vatRate)) {
            return new Big(priceClearTons)
                .plus(totalExcise)
                .round(2)
                .times(vatRate / 100)
                .round(2)
                .toString()
        }
        return null
    }

    static Nds(product, round = 2) {
        const priceClearTon = parseFloat(ProductCalc.PriceClearTon(product))
        const excise = parseFloat(product.tmpExcise)
        const vatRate = parseInt(product.VATRate)
        if (!isNaN(priceClearTon) && !isNaN(excise) && !isNaN(vatRate)) {
            return new Big(priceClearTon)
                .plus(excise)
                .times(vatRate / 100)
                .round(2)
                .toString()
        }
        return null
    }

    static TotalPrice(product, round = 2) {
        const totalNet = parseFloat(ProductCalc.PriceClearTons(product))
        const totalExcise = parseFloat(ProductCalc.TotalExcise(product))
        const totalNds = parseFloat(ProductCalc.TotalNds(product))
        if (!isNaN(totalNet) && !isNaN(totalExcise) && !isNaN(totalNds)) {
            const bigTotalPrice = new Big(totalNet)
            return bigTotalPrice
                .plus(totalExcise)
                .plus(totalNds)
                .toString()
        }
        return null
    }

    static TotalPrice2(product, round = 2) {
        const totalNet = parseFloat(ProductCalc.PriceClearTons(product))
        const totalExcise = parseFloat(ProductCalc.TotalExcise(product))
        const totalNds = parseFloat(ProductCalc.TotalNds(product))
        if (!isNaN(totalNet) && !isNaN(totalExcise) && !isNaN(totalNds)) {
            const bigTotalPrice = new Big(totalNet)

            bigTotalPrice
                .plus(totalExcise)
                .plus(totalNds)
                .toString()

            return bigTotalPrice
                .plus(totalExcise)
                .plus(totalNds)
                .toString()
        }
        return null
    }

}
